<template>
  <div class="flex w-full">
    <div class="data-container w-full">
      <div class="data-container-header">
        <h4>Tehnika</h4>
      </div>
      <div class="data-container-content data-container-table">
        <div class="gwd-table w-full">
          <div class="gwd-table-header equipment-table header">
            <h4>Nimi</h4>
            <h4>Vastutav töötaja</h4>
            <h4>Asukoht</h4>
            <h4 />
          </div>
          <div
            class="equipment-table items-center w-full p-2"
            v-for="equipmentAssignment in taskData.assigned_equipment_list"
            :key="equipmentAssignment.id"
          >
            <div
              class="flex font-medium cursor-pointer"
              @click="navigateToEquipment(equipmentAssignment.equipment.id)"
            >
              {{ equipmentAssignment.equipment.name }}
            </div>
            <span
              class="flex cursor-pointer"
              @click="
                equipmentAssignment.equipment.worker
                  ? navigateToWorker(equipmentAssignment.equipment.worker.id)
                  : null
              "
            >
              {{
                equipmentAssignment.equipment.worker
                  ? equipmentAssignment.equipment.worker.worker_name
                  : ""
              }}
            </span>
            <span>
              {{
                equipmentAssignment.equipment.location
                  ? equipmentAssignment.equipment.location.long_address
                  : ""
              }}
            </span>
            <div class="flex justify-center">
              <button
                class="btn-danger"
                @click.stop.prevent="deleteObject = equipmentAssignment"
              >
                <img
                  src="/bc21/trash.svg"
                  class="h-4 w-4 filter-to-white"
                  alt="Delete eqa"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <confirm-modal
      key="equipment-assignment-delete-modal"
      v-if="deleteObject"
      text="Oled kindel, et soovid tehnika töölt kustutada?"
      @confirm="deleteEquipmentAssignment"
      @closeModal="
        () => {
          this.deleteObject = null;
        }
      "
    />
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import ConfirmModal from "@/components/reusable/ConfirmModal.vue";

export default {
  name: "TaskEquipment",
  components: { ConfirmModal },
  data() {
    return {
      showEditMenu: false,
      deleteObject: null,
    };
  },
  methods: {
    navigateToEquipment(id) {
      this.$router.push(`/equipment/${id}?task_id=${this.taskData.id}`);
      this.$store.dispatch("modals/taskModal/close", this.taskData.id);
    },
    navigateToWorker(id) {
      this.$router.push(`/workers/${id}?task_id=${this.taskData.id}`);
      this.$store.dispatch("modals/taskModal/close", this.taskData.id);
    },
    deleteEquipmentAssignment() {
      this.apiRequest(
        `template/${this.companyId}/equipment/${this.deleteObject.equipment.id}/assignment/${this.deleteObject.id}/delete/`,
        "delete",
        true
      ).then((res) => {
        if (res.status === 200) {
          this.$store.dispatch(
            "modals/taskModal/retrieveTask",
            this.taskData.id
          );
        }
      });
    },
  },
  computed: {
    ...mapState({
      taskData: (state) => state.modals.taskModal.taskData,
    }),
    ...mapGetters({
      companyId: "companyData/activeCompanyUuid",
    }),
  },
};
</script>

<style lang="scss">
.equipment-table {
  @apply grid gap-x-2;
  grid-template-columns: 1fr 1fr 3.6fr 0.2fr;
  @media screen and (max-width: 601px) {
    @apply grid grid-cols-2 gap-y-2;
    &.header {
      display: none !important;
    }
  }
}
</style>
